import React from 'react';
import './Switch.css';

export interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label?: string;
    labelPosition?: 'left' | 'right';
    error?: string;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
    (
        {
            className = '',
            label,
            labelPosition = 'right',
            id,
            error,
            disabled,
            ...props
        },
        ref
    ) => {
        const generatedId = React.useId();
        const switchId = id || generatedId;

        return (
            <div className={`qube-switch-wrapper ${className}`}>
                {label && labelPosition === 'left' && (
                    <label
                        htmlFor={switchId}
                        className={`qube-switch-label qube-switch-label-left ${disabled ? 'qube-switch-label-disabled' : ''}`}
                    >
                        {label}
                    </label>
                )}

                <div className="qube-switch-container">
                    <input
                        type="checkbox"
                        id={switchId}
                        ref={ref}
                        className="qube-switch-input"
                        disabled={disabled}
                        aria-invalid={!!error}
                        {...props}
                    />
                    <div className={`qube-switch-track ${error ? 'qube-switch-error' : ''}`}>
                        <span className="qube-switch-thumb" />
                    </div>
                </div>

                {label && labelPosition === 'right' && (
                    <label
                        htmlFor={switchId}
                        className={`qube-switch-label qube-switch-label-right ${disabled ? 'qube-switch-label-disabled' : ''}`}
                    >
                        {label}
                    </label>
                )}
            </div>
        );
    }
);

Switch.displayName = 'Switch';
